import React from 'react';

export type FieldGroupGap = 'small' | 'medium' | 'large';

export interface FieldGroupProps {
    children: React.ReactNode;
    gap?: FieldGroupGap;
    className?: string;
    style?: React.CSSProperties;
}

const GAP_CLASSES: Record<FieldGroupGap, string> = {
    small: 'gap-5',
    medium: 'gap-10',
    large: 'gap-[60px]',
};

/**
 * Fields that follow from an answer given above them — the credentials a chosen
 * authentication type asks for, say — drawn as its children: indented, with a rule down the side.
 */
export const FieldGroup: React.FC<FieldGroupProps> = ({
    children,
    gap = 'medium',
    className = '',
    style,
}) => (
    <div
        className={`flex flex-col items-stretch w-full pl-5 border-l-2 border-solid border-[var(--malachite-card-border,rgb(232,232,232))] ${GAP_CLASSES[gap]} ${className}`.trim()}
        style={style}
    >
        {children}
    </div>
);

export default FieldGroup;
